import React, {Component} from "react";
import _ from 'i18n';
import FrequencyFilter
  from "../../../Filters/EventStats/EventRegistrantLinechart/FrequencyFilter";
import {Checkbox, DatePicker} from 'antd';
import moment from 'moment'
import LanguagesFilter
  from "../../../Filters/EventStats/EventRegistrantLinechart/LanguagesFilter";
import RegistrationCAFilter
  from "../../../Filters/EventStats/EventRegistrantLinechart/RegistrationCAFilter";
import TypeFormatFilter from "../../../Filters/EventStats/EventRegistrantLinechart/TypeFormatFilter";


export default class EventLineChartFilters extends Component {

  // It's optionel : select only months of the selected year
  disabledYears = (current) => {
    const {eventStatsFilter, period} = this.props;
    return current.year() != period[0].substr(0, 4);
  }

  handleMonthPickerChange = (date, dateString) => {
    this.props.updatePeriod([dateString]);
  }

  render() {
    const {
      frequency,
      updateFrequency,
      period,
      language,
      languages,
      updateLanguages,
      type,
      legendType,
      updateChartType,
      updateLegendType,
      eventStatsFilter,
      showAccumulateEventStats,
      handleShowAccumulateEventStats,
    } = this.props;
    const {MonthPicker} = DatePicker;
    moment.locale(language);

    return (
      <div className={'event-filters-nav'}>
        <div style={{width: '40%'}}>
          <TypeFormatFilter legendType={legendType} updateLegendType={updateLegendType}/>
        </div>
        {eventStatsFilter.year.length === 1 &&
          <div className={'flex items-center'} style={{width: '60%', justifyContent: frequency === 'DAILY' ? 'space-between' : 'flex-end'}}>
            {/* <div style={{width: '80%'}}>
              <RegistrationCAFilter type={type} updateType={updateChartType}/>
            </div> */}
            {
              frequency == 'DAILY' &&
              <MonthPicker onChange={this.handleMonthPickerChange}
                           defaultValue={moment(period[0], 'YYYY-MM')}
                           allowClear={false} disabledDate={this.disabledYears}
                           className={'event-registrant-line-chart-month-picker'}
                           dropdownClassName={"event-registrant-line-chart-month-picker"}
              />
            }

            {frequency === 'DAILY' && <Checkbox checked={showAccumulateEventStats} onChange={handleShowAccumulateEventStats}>Voir la courbe cumulative</Checkbox>}
            
            <div className={'flex'}>
              <LanguagesFilter languages={languages}
                               updateLanguages={updateLanguages}/>
              <FrequencyFilter frequency={frequency}
                               updateFrequency={updateFrequency} fetching={this.props.fetching}/>
            </div>
          </div>
        }
      </div>
    );
  }
}







// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/EventLineChartFilters.js